<template>
  <div class="element-box">
    <div class="full-chat-w">
      <div class="full-chat-middle">
        <div class="chat-head ps-0">
          <div class="user-info">
            {{ $t('general.messages') }}
          </div>
        </div>

        <div class="chat-content-w" style="height: 550px!important;">
          <div class="chat-content pe-3 ps-0">
            <div v-for="message in messages" :key="message.id">

              <div v-if="currentUser.user.id === message.sentBy.id" class="chat-message self">
                <div class="chat-message-content-w">
                  <div class="chat-message-content"
                       style="background-color: rgba(67, 173, 78, 0.5)!important;">
                    {{ message.text }}
                  </div>
                </div>
                <div class="chat-message-date">
                  {{ message.createdAt }}
                </div>
                <div class="chat-message-avatar">
                  <img alt="" src="../../../../../assets/img/user.jpg">
                </div>
              </div>

              <div v-else class="chat-message">
                <div class="chat-message-content-w">
                  <div class="chat-message-content"
                       style="background-color: #f0f9ff!important;">
                    {{ message.text }}
                  </div>
                </div>
                <div class="chat-message-avatar">
                  <img alt="" src="../../../../../assets/img/user.jpg">
                </div>
                <div class="chat-message-date">
                  {{ message.createdAt }}
                </div>
              </div>

            </div>
          </div>
        </div>

        <form @submit.prevent="sendMessage" novalidate
              v-if="travelExpenses?.status !== 'draft' && travelExpenses?.status !== 'approved'">
          <div style="margin-bottom: -42px; margin-left: -15px; margin-top: 30px;">
            <i style="font-size: 26px; color: #43ad4e;" class="os-icon os-icon-mail-07"></i>
          </div>

          <div class="chat-controls">
            <label style="width: 100%; border-bottom: 1px solid #43ad4e">
              <input name="message"
                     v-model="formData.text"
                     :placeholder="$t('general.message_placeholder')"
                     autocomplete="off"
                     type="text"
                     style="
                         border: none;
                         display: block;
                         width: 100%;
                         outline: none;
                         padding: 15px 20px 10px 0;
                         font-size: 14px;">
            </label>
          </div>
          <div class="text-center">
            <button class="btn btn-primary" type="submit">{{ $t('general.button.save') }}</button>
          </div>
        </form>
        <div v-else>
          <p style="text-align: center; font-size: 16px;">
            Sie können nur Nachrichten erstellen, wenn der Status nicht genehmigt ist
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import travelExpensesService from '@/api/TravelExpenses';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import { computed, defineProps, onMounted, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

const piniaUserState = piniaUserStore();
const currentUser    = computed(() => piniaUserState.currentUser);
const { t }          = useI18n();
const isSubmitting   = ref(false);
const messages       = ref([]);

const props = defineProps({
  travelExpenses: {
    type: Object,
    required: false,
  },
});

const { travelExpenses } = toRefs(props);
const travelExpensesId   = travelExpenses?.value?.id;

const formData = ref({
  travelExpensesId: travelExpensesId,
  text: '',
});

async function sendMessage() {
  try {
    if (isSubmitting.value) return;
    isSubmitting.value = true;

    await travelExpensesService.saveMessage(formData.value);
    await getMessages(travelExpensesId);

    isSubmitting.value = false;
    formData.value.text = ''
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getMessages() {
  const { data } = await travelExpensesService.getMessages(travelExpensesId);
  messages.value = data.data;
}

onMounted(async () => {
  if(travelExpensesId){
    await getMessages();
  }
});

</script>

<style scoped>

</style>